module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": _vm.jobInfoTitle,
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "jobInfo",
    attrs: {
      "model": _vm.jobInfo,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "siteId",
      "label": "站点ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.jobInfo.siteId),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "siteId", $$v)
      },
      expression: "jobInfo.siteId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "taskId",
      "label": "任务ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.jobInfo.taskId),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "taskId", $$v)
      },
      expression: "jobInfo.taskId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "taskCode",
      "label": "任务Code"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobInfo.taskCode),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "taskCode", $$v)
      },
      expression: "jobInfo.taskCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "作业类型",
      "prop": "jobType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.jobInfo.jobType),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "jobType", $$v)
      },
      expression: "jobInfo.jobType"
    }
  }, _vm._l((_vm.$option.jobTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "作业名",
      "prop": "jobName"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "存储后的作业名称为：站点ID_作业名  如：1_SaturnJavaJob",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "如SaturnJavaJob"
    },
    model: {
      value: (_vm.jobInfo.jobName),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "jobName", $$v)
      },
      expression: "jobInfo.jobName"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.$option.isJava(_vm.jobInfo.jobType)) ? _c('el-form-item', {
    attrs: {
      "label": "作业实现类",
      "prop": "jobClass"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "如com.vip.saturn.job.SaturnJavaJob"
    },
    model: {
      value: (_vm.jobInfo.jobClass),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "jobClass", $$v)
      },
      expression: "jobInfo.jobClass"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.$option.isCron(_vm.jobInfo.jobType)) ? _c('el-form-item', {
    attrs: {
      "label": "cron表达式",
      "prop": "cron"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "作业启动时间的cron表达式。如每10秒运行:*/10****?,每5分钟运行:0*/5***?",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobInfo.cron),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "cron", $$v)
      },
      expression: "jobInfo.cron"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.checkAndForecastCron
    },
    slot: "append"
  }, [_vm._v("预测")])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [(_vm.$option.isCron(_vm.jobInfo.jobType)) ? _c('el-form-item', {
    staticClass: "form-annotation"
  }, [_c('span', [_vm._v("1. 每10秒运行一次的表达式：*/10 * * * * ?")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("2. 每分钟运行一次的表达式：0 * * * * ?")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "作业分片总数",
      "prop": "shardingTotalCount"
    }
  }, [(_vm.jobInfo.downStream) ? _c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.jobInfo.downStream.length > 0 ? '该作业有下游作业，作业分片数必须为1' : '作业分片数'))])]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.jobInfo.downStream.length > 0,
      "controls-position": "right",
      "min": 1
    },
    model: {
      value: (_vm.jobInfo.shardingTotalCount),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "shardingTotalCount", $$v)
      },
      expression: "jobInfo.shardingTotalCount"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分片参数",
      "prop": "shardingItemParameters"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                分片序列号和参数用等号分隔，多个键值对用逗号分隔 。分片序列号从0开始，不可大于或等于作业分片总数。如：0=a,1=b,2=c;"), _c('br'), _vm._v("\n                                英文双引号请使用!!代替，英文等号请使用@@代替，英文逗号请使用##代替。"), _c('br'), _vm._v("\n                                如果作业所有分片无须参数，则只要保持值为0。例如有2个分片无须参数，则为“0=0,1=0”。"), _c('br'), _vm._v("\n                                对于本地模式的作业，格式为*=value\n                            ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobInfo.shardingItemParameters),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "shardingItemParameters", $$v)
      },
      expression: "jobInfo.shardingItemParameters"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "自定义参数",
      "prop": "jobParameter"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "配置格式: 多个配置使用逗号分隔(key1=value1, key2=value2)。在分片序列号/参数对照表中可作为alias形式引用，格式为{key1}",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobInfo.jobParameter),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "jobParameter", $$v)
      },
      expression: "jobInfo.jobParameter"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.$option.isPassive(_vm.jobInfo.jobType)) ? _c('el-form-item', {
    attrs: {
      "prop": "upStream",
      "label": "上游作业"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                满足上游作业的条件"), _c('br'), _vm._v("1.只能是定时作业或被动作业"), _c('br'), _vm._v("2.分片只能为1"), _c('br'), _vm._v("3.不能是本地模式作业"), _c('br'), _vm._v("4.不能是本作业的直接或者间接下游\n                            ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.jobInfo.upStream),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "upStream", $$v)
      },
      expression: "jobInfo.upStream"
    }
  }, _vm._l((_vm.upStreamProvided), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.$option.isPassive(_vm.jobInfo.jobType)) ? _c('el-form-item', {
    attrs: {
      "prop": "downStream",
      "label": "下游作业"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                配置下游作业的条件"), _c('br'), _vm._v("1.只能是定时作业或被动作业"), _c('br'), _vm._v("2.分片只能为1"), _c('br'), _vm._v("3.不能是本地模式作业"), _c('br'), _c('br'), _vm._v("\n                                满足下游作业的条件"), _c('br'), _vm._v("1.只能是被动作业"), _c('br'), _vm._v("2.不能是本作业的直接或者间接上游\n                            ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "disabled": _vm.jobInfo.localMode || _vm.jobInfo.shardingTotalCount !== 1
    },
    model: {
      value: (_vm.jobInfo.downStream),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "downStream", $$v)
      },
      expression: "jobInfo.downStream"
    }
  }, _vm._l((_vm.downStreamProvided), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.$option.isMsg(_vm.jobInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Queue名",
      "prop": "queueName"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                消息类型job的queue名\n                            ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobInfo.queueName),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "queueName", $$v)
      },
      expression: "jobInfo.queueName"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobInfo.description),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "description", $$v)
      },
      expression: "jobInfo.description"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), (_vm.isCronPredictVisible) ? _c('div', [_c('CronPredictDialog', {
    attrs: {
      "cron-predict-params": _vm.cronPredictParams
    },
    on: {
      "close-dialog": _vm.closeCronDialog
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27462d58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dialog/job_info_dialog.vue
// module id = 1388
// module chunks = 1